export function isLoadIgnore(path:string): boolean{
    const params = path.split('?');
    let ignore = false;
    if(params[1] && params[1].indexOf('loadIgnore')!==-1){
        ignore = true;
    }
    return ignore  
}